import { BsArrowUpCircleFill } from "react-icons/bs";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <BsArrowUpCircleFill
      style={{ width: "100%", position: "absolute", backgroundColor: "red" }}
    />
  );
}

export default ScrollToTop;
